// src/app/core/store/claim-analytics/claim-analytics.selectors.ts

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ClaimAnalyticsState } from './claim-analytics.state';

export const CLAIM_ANALYTICS_FEATURE_KEY = 'claimAnalytics';

export const selectClaimAnalyticsState =
  createFeatureSelector<ClaimAnalyticsState>(CLAIM_ANALYTICS_FEATURE_KEY);

// ── Products ─────────────────────────────────────────────────────────────────
export const selectCaProducts             = createSelector(selectClaimAnalyticsState, s => s.products);
export const selectCaProductsLoading      = createSelector(selectClaimAnalyticsState, s => s.productsLoading);
export const selectCaProductsLoaded       = createSelector(selectClaimAnalyticsState, s => s.productsLoaded);
export const selectCaSelectedProductTypeId = createSelector(selectClaimAnalyticsState, s => s.selectedProductTypeId);

// ── Config ───────────────────────────────────────────────────────────────────
export const selectCaConfigs       = createSelector(selectClaimAnalyticsState, s => s.configs);
export const selectCaConfigLoading = createSelector(selectClaimAnalyticsState, s => s.configLoading);

export const selectCaActiveConfig = createSelector(
  selectCaConfigs,
  selectCaSelectedProductTypeId,
  (configs, id) => id !== null ? configs[id] ?? null : null,
);

// ── Lookups ──────────────────────────────────────────────────────────────────
export const selectCascoCauses              = createSelector(selectClaimAnalyticsState, s => s.cascoCauses);
export const selectCascoCausesLoaded        = createSelector(selectClaimAnalyticsState, s => s.cascoCausesLoaded);
export const selectHealthBenefitTypes       = createSelector(selectClaimAnalyticsState, s => s.healthBenefitTypes);
export const selectHealthBenefitTypesLoaded = createSelector(selectClaimAnalyticsState, s => s.healthBenefitTypesLoaded);

// ── Overview ─────────────────────────────────────────────────────────────────
export const selectCaOverview        = createSelector(selectClaimAnalyticsState, s => s.overview);
export const selectCaOverviewData    = createSelector(selectCaOverview, s => s.data);
export const selectCaOverviewLoading = createSelector(selectCaOverview, s => s.loading);
export const selectCaOverviewError   = createSelector(selectCaOverview, s => s.error);

// ── TimeSeries ───────────────────────────────────────────────────────────────
export const selectCaTimeSeries        = createSelector(selectClaimAnalyticsState, s => s.timeSeries);
export const selectCaTimeSeriesData    = createSelector(selectCaTimeSeries, s => s.data);
export const selectCaTimeSeriesLoading = createSelector(selectCaTimeSeries, s => s.loading);
export const selectCaTimeSeriesError   = createSelector(selectCaTimeSeries, s => s.error);

// ── Breakdown ────────────────────────────────────────────────────────────────
export const selectCaBreakdown        = createSelector(selectClaimAnalyticsState, s => s.breakdown);
export const selectCaBreakdownData    = createSelector(selectCaBreakdown, s => s.data);
export const selectCaBreakdownLoading = createSelector(selectCaBreakdown, s => s.loading);
export const selectCaBreakdownError   = createSelector(selectCaBreakdown, s => s.error);

// ── Rankings ─────────────────────────────────────────────────────────────────
export const selectCaRankings        = createSelector(selectClaimAnalyticsState, s => s.rankings);
export const selectCaRankingsData    = createSelector(selectCaRankings, s => s.data);
export const selectCaRankingsLoading = createSelector(selectCaRankings, s => s.loading);
export const selectCaRankingsError   = createSelector(selectCaRankings, s => s.error);

// ── Comparison ───────────────────────────────────────────────────────────────
export const selectCaComparison        = createSelector(selectClaimAnalyticsState, s => s.comparison);
export const selectCaComparisonData    = createSelector(selectCaComparison, s => s.data);
export const selectCaComparisonLoading = createSelector(selectCaComparison, s => s.loading);
export const selectCaComparisonError   = createSelector(selectCaComparison, s => s.error);
